import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useOneLinkUrl } from "contexts/OneLinkScript"
import dynamic from "next/dynamic"
import QRCodeComponent from "pazChargeComponents/general/QRCode"
import animationData from 'public/animation/Charge_micro.json'
import colors from "theme/colors"
import { Container, Desktop, Mobile, NewText, TitleWithLine, extractProperty } from "ui"
import { sharedColors } from "ui/theme/colors"
import QRCodeInMapCharge from "./QRCodeInMapCharge"


const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
`
const StyledBlockFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const StyledTitleAndText = styled.div`
`
// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const StyledButton = styled(Button)`
  width: 216px;
  height: 32px;
//    padding: 8px 20px 8px 20px;
  border-radius: 24px;
//   opacity: 0px;
  background-color: ${sharedColors.blue};
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;

  ${(props) => props.theme.breakpoints.up("md")} {
    height: 45px;
    width: 220px;
    border-radius: 40px;
  }
`
const StyledLottie = styled.div`
margin-top: 5px;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`
const StyledNewText = styled(NewText)`
padding: 10px 0px;

`


type Props = {
  data: any

}
function MapDownloadAppChargeBlock({ data }: Props) {
  const { oneLinkUrl } = useOneLinkUrl()
  const title = extractProperty(data, "title")
  const subTitle = extractProperty(data, "subTitle")



  return (
    <Container padding={0}>
      <StyledWrapper>
        <StyledBlockFooter>
          <StyledTitleAndText>
            <TitleWithLine
              component={"h2"}
              largeDesktopFontSize={34}
              largeDesktopLineHeight="36px"
              titleFontSize={34}
              desktopLineHeight={"36px"}
              mobileTitleFontSize={24}
              mobileLineHeight={"28px"}
              desktopFontWeight={500}
              title={title}
              titleColor={colors.black}
            />
            <StyledNewText
              component={"p"}
              largeDesktopFontSize={18}
              largeDesktopLineHeight="20px"
              desktopFontSize={18}
              desktopLineHeight={"20px"}
              desktopFontWeight={400}
              mobileFontSize={16}
              mobileLineHeight={"18px"}
              mobileFontWeight={400}
            >
              {subTitle}
            </StyledNewText>
          </StyledTitleAndText>
          <Desktop>
            <QRCodeInMapCharge url={oneLinkUrl}/>
          </Desktop>
        </StyledBlockFooter>
        <Mobile>
          <StyledButton variant="contained" href={oneLinkUrl}>
            להורדת האפליקצייה
            <StyledLottie>
              <Lottie animationData={animationData} loop={true} />
            </StyledLottie>
          </StyledButton>
        </Mobile>
      </StyledWrapper>
    </Container>
  );
}

export default MapDownloadAppChargeBlock;
